<template>
  <!-- For left menu navigation, i will set 3 it to max 3 tiers-->
  <v-navigation-drawer persistent fixed clipped app v-model="menuModel" id="leftMenu">
    <v-list subheader dense>
      <template v-for="(item, i) in items">
        <div v-if="!item.hidden" :key="i">
          <v-subheader>{{ item.text }}</v-subheader>
          <template v-if="item.children">
            <template v-for="(secondLevel, x) in item.children">
              <v-list-group v-if="!secondLevel.route" v-model="secondLevel.active" :key="x" :prepend-icon="secondLevel.icon? secondLevel.icon : 'mdi-folder'">
                <v-list-tile slot="activator">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ secondLevel.text }}</v-list-tile-title>
                    <v-list-tile-sub-title v-if="secondLevel.desc">{{ secondLevel.desc }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile v-for="(thirdLevel, y) in secondLevel.children" :key="y" @click="launchApp(thirdLevel.name, thirdLevel.route)">
                  <v-list-tile-action>
                    <v-icon v-if="thirdLevel.icon">{{ thirdLevel.icon }}</v-icon>
                    <v-icon v-else>{{ thirdLevel.route ? 'mdi-launch' : 'mdi-folder'}}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ thirdLevel.text }}</v-list-tile-title>
                    <v-list-tile-sub-title v-if="thirdLevel.desc">{{ thirdLevel.desc }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <v-list-tile v-else :key="x" @click="launchApp(secondLevel.name, secondLevel.route)">
                <v-list-tile-action>
                  <v-icon>{{ secondLevel.icon? secondLevel.icon : 'mdi-launch'}}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ secondLevel.text }}</v-list-tile-title>
                  <v-list-tile-sub-title v-if="secondLevel.desc">{{ secondLevel.desc }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </template>
          <v-divider></v-divider>
        </div>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import clone from 'clone'
import { Menu } from '@/const/menu'
import Routable from '@/mixins/routable'
import { addAccess, removeEmptyChild } from '@/utils/menu'
import { APP_TOGGLE_MENU } from '@/store/types'
import { getCookie } from '@/utils/cookie'
export default {
  data() {
    return {
      items: []
    }
  },
  computed: {
    menuModel: {
      get: function () {
        return this.$store.state.app.toggleMenu
      },
      set: function (newValue) {
        // Has to set this too
        // When screen resize, the menu will be autoclosed (by vuetify layout)
        this.$store.commit(APP_TOGGLE_MENU, newValue)
      }

    }
  },
  methods: {

  },
  beforeMount() {
    // Port in Menu from const and add in access control
    const fullItems = clone(Menu)
    addAccess(fullItems[0].children)
    removeEmptyChild(fullItems[0].children)
    this.items = fullItems[0].children
  },
  beforeCreate() {
    // Check cookie for save state
    const menuCookie = getCookie('menu')
    if (menuCookie !== null && menuCookie === 'false') {
      this.$store.commit(APP_TOGGLE_MENU, false)
    }
  },
  mixins: [
    Routable
  ]
}
</script>

<style>
</style>
